/**
 * 繁體中文本地化資源
 * E.1 + E.3-1 + E.3-2 累計 key
 */
export default {
  layout: {
    brand: 'CardShop 自助購卡機',
    loading: '正在載入，請稍候…',
    offline: '網路連線已斷開',
  },
  error: {
    network: '網路連線失敗，請檢查網路設定',
    unknown: '發生未知錯誤，請聯繫工作人員',
    maintenance: '系統維護中，請稍候',
  },
  common: {
    btn: {
      confirm: '確認',
      cancel: '取消',
      retry: '重試',
      copy: '複製',
    },
  },
  // ── E.3-1 ─────────────────────────────────────────────────────────────────
  home: {
    welcome: '歡迎使用 CardShop 自助購卡機',
    start: '開始購卡 / Start',
    startAria: '點擊開始購卡',
    allCategories: '全部',
  },
  products: {
    title: '選擇商品 / Select Product',
    back: '返回',
    lowStock: '即將售罄',
    outOfStock: '已售罄',
    empty: '暫無可購商品',
    loading: '正在載入商品…',
    createOrderFailed: '創建訂單失敗，請重試',
    activeOrderExists: '您有一個未完成的訂單，請先處理或等待其超時釋放',
    activeOrderExistsRedirecting: '檢測到進行中的訂單，正在為您跳轉...',
  },
  order: {
    title: '訂單詳情 / Order Detail',
    back: '返回',
    payNow: '去支付 / Pay Now',
    cancel: '取消訂單 / Cancel',
    notFound: '訂單不存在，請重新下單',
    cancelComingSoon: '取消訂單功能將在下一期實裝',
    status: {
      PENDING: '待處理',
      IN_PAY: '支付中',
      PAYING: '支付中',
      PAID: '已支付',
      DELIVERING: '出貨中',
      COMPLETED: '已完成',
      FAILED: '失敗',
      CANCELLED: '已取消',
      CANCELED: '已取消',
      FULFILLED: '已出貨',
      TIMEOUT: '支付逾時',
      REFUNDING: '退款中',
      REFUNDED: '已退款',
    },
    statusLoading: '載入中…',
    paidAt: '支付時間',
    createdAt: '創建時間',
    unitPrice: '單價',
    paidAmount: '已支付',
    statusLabel: '狀態',
    cardNumber: '卡號',
    cardKey: '卡密',
    invoice: '發票',
    invoiceNo: '發票號',
    invoiceIssued: '已開票',
    invoiceApply: '申請發票',
    invoiceApplyTitle: '申請電子發票',
    invoiceCarrierType: '載具類型',
    invoiceCarrierNone: '無載具（雲端儲存）',
    invoiceCarrierMobile: '手機條碼',
    invoiceCarrierCDC: '載具號碼',
    invoiceCarrierEZ: '悠遊卡/icash',
    invoiceCarrierEmail: '電子郵件',
    invoiceCarrierDonation: '捐贈發票',
    invoiceCarrierId: '載具號碼',
    invoiceCarrierIdPlaceholder: '請輸入載具號碼',
    invoiceEmail: '電子郵件',
    invoiceEmailPlaceholder: '請輸入電子郵件',
    invoiceDonationHint: '發票將捐贈給伊甸社會福利基金會（愛心碼 25885）',
    invoiceSubmit: '確認申請',
    invoiceSubmitting: '申請中...',
    invoiceSuccess: '發票申請成功！發票號：{no}',
    invoiceSuccessDonation: '感謝您的愛心捐贈！發票已捐贈給伊甸社會福利基金會',
    invoiceFailed: '發票申請失敗，請重試',
    invoiceDuplicate: '該訂單已申請過發票',
    invoiceAutoSubmit: '以捐贈提交 ({seconds}s)',
    invoiceAutoSubmitDone: '已自動捐贈發票',
    processSteps: '後續流程步驟',
    redeemInfo: '兌換資訊',
    processing: '處理中...',
    loadingPayload: '正在取得卡號/卡密，請稍候…',
    retryPayload: '重新取得卡號/卡密',
    payloadLoaded: '卡號/卡密已取得',
    payloadFailed: '取得卡號/卡密失敗，請重試',
    copySuccess: '已複製到剪貼簿',
    copyFailed: '複製失敗，請手動複製',
    sendCardEmail: '發送卡密到信箱',
    sendCardEmailTitle: '發送卡密到信箱',
    sendCardEmailHint: '卡號和卡密將發送到您填寫的信箱，請確認信箱地址正確',
    sendCardEmailInput: '請輸入信箱地址',
    sendCardEmailSubmit: '發送',
    sendCardEmailSending: '發送中...',
    sendCardEmailSuccess: '卡密已發送，請查收信件',
    sendCardEmailFailed: '發送失敗，請重試',
    qrVerifyTitle: '核銷二維碼',
    qrVerifyHint: '商家掃描可驗證此卡密是否已從機器發放',
    qrVerifyLoading: '二維碼產生中…',
    qrVerifyRetry: '重新取得二維碼',
    customerContact: '客服聯絡',
    customerContactNone: '如需協助請聯絡工作人員',
    customerContactTitle: '聯絡客服',
    customerContactClose: '關閉',
  },
  ad: {
    exitTip: '觸碰螢幕退出廣告',
  },
  // ── E.3-2 maintenance ─────────────────────────────────────────────────────
  maintenance: {
    title: '設備維護中 / Under Maintenance',
    retry: '重新連線',
    network_offline: '網路連線已斷開，請檢查網路',
    auth_failed: '設備認證失敗，請聯絡客服',
    machine_locked: '設備已被遠端鎖定',
    dtu_offline: '售卡設備離線，正在等待恢復',
    unknown: '系統發生未知故障',
    reconnecting: '正在嘗試重新連線…',
    wsStatus: 'WS 連線狀態',
    networkOnline: '網路在線',
    networkOffline: '網路離線',
    contactTitle: '聯絡運維支持',
    contactPhoneLabel: '熱線電話',
    contactPhone: '400-888-0000',
    contactWechat: '@cardshop_support',
    workOrder: '提交工單：support.cardshop.com',
  },
  // ── E.3-2 pay ─────────────────────────────────────────────────────────────
  pay: {
    title: '支付 / Payment',
    summary: '訂單摘要',
    orderPayment: '訂單支付',
    method: '支付方式',
    cash: '紙鈔',
    linepay: 'LinePay',
    card: '信用卡',
    applepay: 'Apple Pay',
    comingSoon: '此支付方式即將開放',
    insertBill: '請投入紙鈔',
    remaining: '還需支付',
    completed: '支付完成！',
    cancelled: '支付已取消',
    billReceived: '已投入 {amount}',
    billInsertedFull: '已投入 {inserted}',
    billInsertedStatus: '已投入 {inserted}，還需支付 {remaining}',
    contactSupport: '聯絡客服',
    cancelOrder: '取消訂單',
    timeout: '長時間未操作，請儘快完成支付',
    orderNotFound: '訂單不存在，請重新下單',
    fullyPaidRedirect: '支付完成，正在跳轉…',
    // ── F.12 新增：找零 / 拒鈔 / 超時 ──────────────────────────────────────
    change: {
      label: '請取走找零 {amount}',
    },
    billRejected: '機器暫時未能讀取紙鈔，請稍候再試。如多次失敗請通知工作人員',
    billTimeout: '投鈔超時，訂單已自動取消，請重新選購',
    countdown: '請在 {time} 內完成投鈔，超時訂單將自動取消',
    countdownExpired: '訂單已超時，請重新選購',
  },
  // ── E.3-2 toast ───────────────────────────────────────────────────────────
  toast: {
    dismiss: '關閉',
  },
  header: {
    online: '在線',
    offline: '離線',
    reconnecting: '重連中',
  },
  footer: {
    online: '網路正常',
    offline: '網路斷開',
    reconnecting: '網路重連',
  },
}
